// extracted by mini-css-extract-plugin
export default {"space_10":"index_space_10_TLC0R"};